import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  pageTitle: string | null;
  homeTo?: string;
};

const AppHeaderTitle: React.FC<Props> = ({ pageTitle, homeTo = '/' }) => {
  const logoAsdecyl = `${process.env.PUBLIC_URL || ''}/logo-asdecyl.jpg`;

  return (
    <div className="flex items-center gap-2 min-w-0 flex-1">
      <Link to={homeTo} className="flex items-center gap-2 shrink-0">
        <img
          src={logoAsdecyl}
          alt="ASDECYL"
          width={120}
          height={32}
          className="h-8 w-auto object-contain"
        />
        <span className="text-base font-semibold text-scout-green-dark hidden sm:inline whitespace-nowrap">
          Tesorería Scouts
        </span>
      </Link>
      {pageTitle ? (
        <h1 className="text-base font-semibold text-scout-green-dark truncate min-w-0">
          <span className="hidden sm:inline font-normal text-scout-green-dark/40"> - </span>
          <span>{pageTitle}</span>
        </h1>
      ) : (
        <h1 className="text-base font-semibold text-scout-green-dark sm:hidden">Tesorería Scouts</h1>
      )}
    </div>
  );
};

export default AppHeaderTitle;
